<button mat-raised-button color="primary" style="width: fit-content;margin-top:calc(64px);margin-bottom:1rem;margin-left: 1rem;" (click)="createConsultant()">
  <mat-icon>add</mat-icon> Opret ny konsulent
</button>

@if (!loading) {
<!-- <div class="table-container"> -->
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button (click)="openConsultant(element)" matTooltip="Rediger">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="deleteConsultant(element)" matTooltip="Slet">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Navn </th>
      <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
    </ng-container>
    <ng-container matColumnDef="initials">
      <th mat-header-cell *matHeaderCellDef> Initialer </th>
      <td mat-cell *matCellDef="let element"> {{element?.initials}} </td>
    </ng-container>
    <ng-container matColumnDef="department">
      <th mat-header-cell *matHeaderCellDef> Forretningsområde </th>
      <td mat-cell *matCellDef="let element"> {{department(element.departmentId)}} </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element"> {{element?.email}} </td>
    </ng-container>
    <ng-container matColumnDef="dashboardAccess">
      <th mat-header-cell *matHeaderCellDef> Dashboard adgang </th>
      <td mat-cell *matCellDef="let element"> {{element?.dashboardAccess ? 'Ja' : 'Nej'}} </td>
    </ng-container>
    <ng-container matColumnDef="includedInDashboard">
      <th mat-header-cell *matHeaderCellDef> Medtaget i dashboard </th>
      <td mat-cell *matCellDef="let element"> {{element?.includedInDashboard ? 'Ja' : 'Nej'}} </td>
    </ng-container>
    <ng-container matColumnDef="monthlySalary">
      <th mat-header-cell *matHeaderCellDef> Lønomk. mdl. </th>
      <td mat-cell *matCellDef="let element"> {{$safeNavigationMigration(currentSalary(element)?.monthlySalary) | number: '1.0-0'}} </td>
    </ng-container>
    <ng-container matColumnDef="monthlySharedExpenses">
      <th mat-header-cell *matHeaderCellDef> Fællesomk. mdl. </th>
      <td mat-cell *matCellDef="let element"> {{$safeNavigationMigration(currentSalary(element)?.monthlySharedExpenses) | number: '1.0-0'}} </td>
    </ng-container>
    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> Position </th>
      <td mat-cell *matCellDef="let element">
        @if (currentSalary(element); as s) {
          {{POSITION_LABELS[s.position ?? Position.None]}}
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="bonusPercentage">
      <th mat-header-cell *matHeaderCellDef> Bonus % </th>
      <td mat-cell *matCellDef="let element">
        @if (currentSalary(element); as s) {
          {{s.bonusPercentage | number: '1.0-0'}}%
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true" class="header-row"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
<!-- </div> -->
}